import { useEffect, useState } from 'react'
import { productShortCodes } from '../../../lib/constants'
import { KitEvalPlatform, KitEvalResponseItem } from '../types'

export const useSignupProductOptions = (
  options: {
    productShortCode: string | null
    productVariant: string | null
    operatingSystem: string | null
  } = {
      operatingSystem: null,
      productShortCode: null,
      productVariant: null,
    },
) => {
  const productOptions = productShortCodes
  const [productVariantOptions, setProductVariantOptions] = useState<KitEvalResponseItem[]>([])
  const [operatingSystemOptions, setOperatingSystemOptions] = useState<KitEvalPlatform[]>([])

  const { productShortCode, productVariant } = options

  useEffect(() => {
    setProductVariantOptions([])
    if (productShortCode && productShortCode.length > 0) {
      fetch(`${process.env.GATSBY_PDFTOOLS_API_URL}/Kits/EvalItems/${productShortCode}`)
        .then(response => response.json())
        .then((data: KitEvalResponseItem[]) => {
          setProductVariantOptions(data)
        })
    }
  }, [productShortCode, productVariant])

  useEffect(() => {
    setOperatingSystemOptions([])
    if (productVariant && productVariant.length > 0) {
      const item = productVariantOptions.find(item => item.variant === productVariant)
      if (item) {
        setOperatingSystemOptions(item.platforms)
      }
    }
  }, [productVariantOptions, productVariant])

  return {
    productOptions,
    productVariantOptions,
    operatingSystemOptions,
  }
}
